"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        colorSuccess: {
            backgroundColor: '#a5d6a7',
            color: "#2B304F",
            fontSize: 14,
            fontWeight: 'bold',
            fontFamily: "Inter"
        },
        colorError: {
            backgroundColor: '#D35555',
            color: "#E2E6F3",
            fontSize: 14,
            fontWeight: 'bold',
            fontFamily: "Inter"
        },
        colorInfo: {
            backgroundColor: '#E2E6F3',
            color: "#2B304F",
            fontSize: 14,
            fontWeight: 'bold',
            fontFamily: "Inter"
        },
        colorWarning: {
            backgroundColor: '#ffb74d',
            color: "#2B304F",
            fontSize: 14,
            fontWeight: 'bold',
            fontFamily: "Inter"
        },
        colorDefault: {
            backgroundColor: '#E2E6F3',
            color: "#2B304F",
            fontSize: 14,
        },
        linkColor: {
            color: "#1DA1F2",
            fontFamily: "Inter"
        },
        iconColor: {
            color: "#2B304F",
            fontFamily: "Inter"
        },
        closeButton: {
            fontFamily: "Inter"
        }
    });
});
